export default "__VITE_ASSET__BQGITr1S__"